import React from 'react';
import { PropTypes } from 'prop-types';
import classnames from 'classnames';
import styled from 'styled-components';

import Asterisk from '@atoms/Asterisk/index';
import TooltipInfo from '@atoms/TooltipInfo/TooltipInfo';
import LoadingInline from '@molecules/LoadingInline'; // TODO: should an atom reference a molecule?
import { BodySmall, LabelLarge } from '@styled';
import colors from '@general/colors';

const StyledStrengthIndicator = styled.div`
    > div {
        background-color: lightgrey;
    }

    &.password-score-1 {
        div:nth-child(1) {
            background-color: #e34e3d;
        }
    }

    &.password-score-2 {
        div:nth-child(1),
        div:nth-child(2) {
            background-color: #e34e3d;
        }
    }

    &.password-score-3 {
        div:nth-child(1),
        div:nth-child(2),
        div:nth-child(3) {
            background-color: #5bd39c;
        }
    }

    &.password-score-4 {
        > div {
            background-color: #5bd39c;
        }
    }
`;

const PasswordStrengthIndicator = ({ score }) => {
    return (
        <StyledStrengthIndicator className={`password-score-${score} d-flex w-100 mt-2`} style={{ height: '8px' }}>
            <div className="w-25 mr-1" />
            <div className="w-25 mr-1" />
            <div className="w-25 mr-1" />
            <div className="w-25" />
        </StyledStrengthIndicator>
    );
};

const InputStyled = styled.input`
    border: 1px solid ${colors.lightGray};

    &[disabled] {
        background-color: ${colors.ultraLightGray};
        color: ${colors.darkGray};
    }
`;

const PasswordInput = ({ label, infoText = '', isLoading, shouldAutoFocus, ...props }) => {
    // eslint-disable-next-line no-unused-vars
    const { id, name, required, error, score } = props;
    const groupClasses = classnames('form-group', { 'has-danger': error !== null });
    const inputClasses = classnames('form-control', 'p-3', { 'form-control-danger': error !== null });

    return (
        <>
            <div className={groupClasses}>
                {label && (
                    <label className="flex" htmlFor={id || name}>
                        <LabelLarge>
                            {label} {required && <Asterisk />}
                        </LabelLarge>

                        {infoText !== '' && (
                            <span className="ml-0.25rem">
                                <TooltipInfo text={infoText} />
                            </span>
                        )}
                    </label>
                )}

                {isLoading && <LoadingInline />}
                {!isLoading && (
                    <>
                        <InputStyled type="password" className={inputClasses} autoFocus={shouldAutoFocus} {...props} />
                        {typeof score === 'number' && <PasswordStrengthIndicator score={score} />}
                        {error !== null && <BodySmall className="mt-0.25rem text-error">{error}</BodySmall>}
                    </>
                )}
            </div>
        </>
    );
};

PasswordStrengthIndicator.propTypes = {
    score: PropTypes.number,
};

PasswordInput.propTypes = {
    label: PropTypes.string,
    infoText: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    name: PropTypes.string,
    required: PropTypes.bool,
    isLoading: PropTypes.bool,
    score: PropTypes.number,
    shouldAutoFocus: PropTypes.bool,
};

export default PasswordInput;
